import PropTypes from 'prop-types';
import React from 'react';
import close from '../../assets/close.png';

import style from './close-button.css';

const CloseButton = props => (
    <div
        className={style.closeContainer}
        onClick={props.onClick}
    >
        <img src={close} />
    </div>
);

CloseButton.propTypes = {
    onClick: PropTypes.func
};

export default CloseButton;
